export const employeeFlag = {
  CCI_INDIA: "CCI_INDIA",
  IRED: "IRED_INDIA",
  ALL: "ALL",
  CCI_US: "CCI_US",
};
